// A mock handler answers an HTTP error by throwing mockError(status, data) (see adapter.js).
export const mockError = (status, data) =>
  Object.assign(new Error(`[mock] ${status}`), { mockStatus: status, mockData: data });
